module.exports = __webpack_public_path__ + "img/16.d53ff79d.jpg";